import React from 'react';

interface AvatarProps {
  name:   string;
  size?:  'sm' | 'md' | 'lg';
  className?: string;
}

// Genera un hue determinista a partir del nombre
function hueFromName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h + name.charCodeAt(i) * 31) % 360;
  }
  return h;
}

export const Avatar: React.FC<AvatarProps> = ({ name, size = 'md', className = '' }) => {
  const initials = name.split(' ').slice(0, 2).map(p => p[0] || '').join('').toUpperCase();
  const h = hueFromName(name);
  const sizeClass = size === 'sm' ? 'avatar-sm' : size === 'lg' ? 'avatar-lg' : '';
  return (
    <div
      className={`avatar ${sizeClass} ${className}`}
      style={{
        background: `linear-gradient(135deg, hsl(${h},65%,55%), hsl(${(h + 40) % 360},70%,45%))`,
      }}
    >
      {initials || '·'}
    </div>
  );
};
